import { Buffer } from 'buffer';

export const objectToBase64 = (object: Record<any, any>) => {
  const objJsonStr = JSON.stringify(object);

  return Buffer.from(objJsonStr).toString('base64');
};
